import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'utils/route-guard/AuthGuard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - crops
const CropsPage = Loadable(lazy(() => import('pages/crops')));
const CropViewPage = Loadable(lazy(() => import('pages/crops/View')));

// render - products
const ProductsPage = Loadable(lazy(() => import('pages/products')));

// render - animals
const AnimalsPage = Loadable(lazy(() => import('pages/animals')));
const AnimalViewPage = Loadable(lazy(() => import('pages/animals/View')));

// render - weeds
const WeedsPage = Loadable(lazy(() => import('pages/weeds')));
const WeedViewPage = Loadable(lazy(() => import('pages/weeds/View')));

// render - trees
const TreesPage = Loadable(lazy(() => import('pages/trees')));
const TreeViewPage = Loadable(lazy(() => import('pages/trees/View')));

// render - flowers
const FlowersPage = Loadable(lazy(() => import('pages/flowers')));
const FlowerViewPage = Loadable(lazy(() => import('pages/flowers/View')));

// render - farm management
const FarmManagementPage = Loadable(lazy(() => import('pages/farm-management')));

// render - marketplace
const MarketplacePage = Loadable(lazy(() => import('pages/marketplace')));

// render - procurement
const ProcurementPage = Loadable(lazy(() => import('pages/procurement')));

// render - suppliers
const SuppliersPage = Loadable(lazy(() => import('pages/suppliers')));

// render - payments
const PaymentsPage = Loadable(lazy(() => import('pages/payments')));

// render - contact
const ContactMessagesPage = Loadable(lazy(() => import('pages/contact')));

// render - users
const UsersPage = Loadable(lazy(() => import('pages/users')));
const UserViewPage = Loadable(lazy(() => import('pages/users/View')));

// render - settings
const SettingsPage = Loadable(lazy(() => import('pages/settings')));

// render - profile
const ProfilePage = Loadable(lazy(() => import('pages/profile')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'crops',
      element: <CropsPage />
    },
    {
      path: 'crops/:id',
      element: <CropViewPage />
    },
    {
      path: 'products',
      element: <ProductsPage />
    },
    {
      path: 'animals',
      element: <AnimalsPage />
    },
    {
      path: 'animals/:id',
      element: <AnimalViewPage />
    },
    {
      path: 'weeds',
      element: <WeedsPage />
    },
    {
      path: 'weeds/:id',
      element: <WeedViewPage />
    },
    {
      path: 'trees',
      element: <TreesPage />
    },
    {
      path: 'trees/:id',
      element: <TreeViewPage />
    },
    {
      path: 'flowers',
      element: <FlowersPage />
    },
    {
      path: 'flowers/:id',
      element: <FlowerViewPage />
    },
    {
      path: 'farm-management',
      element: <FarmManagementPage />
    },
    {
      path: 'marketplace',
      element: <MarketplacePage />
    },
    {
      path: 'procurement',
      element: <ProcurementPage />
    },
    {
      path: 'suppliers',
      element: <SuppliersPage />
    },
    {
      path: 'payments',
      element: <PaymentsPage />
    },
    {
      path: 'contact',
      element: <ContactMessagesPage />
    },
    {
      path: 'users',
      element: <UsersPage />
    },
    {
      path: 'users/:id',
      element: <UserViewPage />
    },
    {
      path: 'settings',
      element: <SettingsPage />
    },
    {
      path: 'profile',
      element: <ProfilePage />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    }
  ]
};

export default MainRoutes;
